var map = {
	"./Amex.svg": 1780,
	"./Apple.svg": 1781,
	"./Arrow-Coverage-Dark.svg": 1782,
	"./Arrow-Coverage-Light.svg": 1783,
	"./Arrow-Coverage.svg": 1784,
	"./Arrow-Element.svg": 1785,
	"./Arrow-Macro-Light.svg": 1786,
	"./Arrow-Macro.svg": 1787,
	"./Arrow-Micro-Dark.svg": 1788,
	"./Arrow-Micro.svg": 1789,
	"./Auth.svg": 1790,
	"./Close-Dark.svg": 1791,
	"./Close-Light.svg": 1792,
	"./Coverage-Dark.svg": 1793,
	"./Coverage-Light.svg": 1794,
	"./Credit-Card.svg": 1795,
	"./Data-Dark-16.svg": 1796,
	"./Data-Dark.svg": 1797,
	"./Data-Light-16.svg": 1798,
	"./Data-Light.svg": 1799,
	"./Down-Arrow.svg": 1800,
	"./Facebook-Original.svg": 1801,
	"./Footer-Amex.svg": 1802,
	"./Footer-Arrow-Close.svg": 1803,
	"./Footer-Arrow-Open.svg": 1804,
	"./Footer-Facebook.svg": 1805,
	"./Footer-Instagram.svg": 1806,
	"./Footer-Linkedin.svg": 1807,
	"./Footer-MasterCard.svg": 1808,
	"./Footer-Paypal.svg": 1809,
	"./Footer-Twitter.svg": 1810,
	"./Footer-VK.svg": 1811,
	"./Footer-Visa.svg": 1812,
	"./Footer-X.svg": 1813,
	"./GooglePlayStore.svg": 1814,
	"./ID.svg": 1815,
	"./Information.svg": 1816,
	"./Inline-American-Express.svg": 1817,
	"./Inline-MasterCard.svg": 1818,
	"./Inline-Unionpay.svg": 1819,
	"./Inline-Visa.svg": 1820,
	"./Input-Search-Dark.svg": 1821,
	"./Input-Search-Light.svg": 1822,
	"./Linkedin-Light.svg": 1823,
	"./Log-out-red.svg": 1824,
	"./Log-out.svg": 1825,
	"./Logo.svg": 1826,
	"./Manual-Install.svg": 1827,
	"./Mastercard.svg": 1828,
	"./PayPal.svg": 1829,
	"./Plus.svg": 1830,
	"./Price-Dark.svg": 1831,
	"./Price-Light.svg": 1832,
	"./QR.svg": 1833,
	"./Readonly-Input-Lock.svg": 1834,
	"./Saved-Amex.svg": 1835,
	"./Saved-MasterCard.svg": 1836,
	"./Saved-Visa.svg": 1837,
	"./Search.svg": 1838,
	"./Secure-Auth.svg": 1839,
	"./Secure-W.svg": 1840,
	"./Secure.svg": 1841,
	"./Share.svg": 1842,
	"./Star_color.svg": 1843,
	"./Store-Active-Dark.svg": 1844,
	"./Store-Active-Light.svg": 1845,
	"./Store-B.svg": 1846,
	"./Store-Inactive.svg": 1847,
	"./Store-W.svg": 1848,
	"./Store.svg": 1849,
	"./Success.svg": 1850,
	"./Trash.svg": 1851,
	"./Twitter-Original.svg": 1852,
	"./User-Active-Dark.svg": 1853,
	"./User-Active-Light.svg": 1854,
	"./User-Inactive.svg": 1855,
	"./Validity-Dark.svg": 1856,
	"./Validity-Light.svg": 1857,
	"./Visa.svg": 1858,
	"./What-is-This.svg": 1859,
	"./copy.svg": 1860,
	"./eSIM-Active-Dark.svg": 1861,
	"./eSIM-Active-Light.svg": 1862,
	"./eSIM-Dark.svg": 1863,
	"./eSIM-Inactive.svg": 1864,
	"./eSIM-Light.svg": 1865,
	"./email.svg": 1866,
	"./facebook.svg": 1867,
	"./ic_add-card.svg": 1868,
	"./ic_airmoney_macro.svg": 1869,
	"./ic_airmoney_micro.svg": 1870,
	"./ic_airmoney_pay.svg": 1871,
	"./ic_airmoney_payment-method.svg": 1872,
	"./ic_alipay_payment-method-dark.svg": 1873,
	"./ic_alipay_payment-method-light.svg": 1874,
	"./ic_amex.svg": 1875,
	"./ic_apple-dark.svg": 1876,
	"./ic_apple-light.svg": 1877,
	"./ic_apple-pay_payment-method.svg": 1878,
	"./ic_arrow_slider_active_Light.svg": 1879,
	"./ic_arrow_slider_inactive_Light.svg": 1880,
	"./ic_back_header-dark.svg": 1881,
	"./ic_back_header-light.svg": 1882,
	"./ic_banner_refeere.svg": 1883,
	"./ic_banner_referrer.svg": 1884,
	"./ic_bill_to_org_payment-method-light.svg": 1885,
	"./ic_calls.svg": 1886,
	"./ic_checkbox_active.svg": 1887,
	"./ic_checkbox_inactive.svg": 1888,
	"./ic_chevron-right.svg": 1889,
	"./ic_chip.svg": 1890,
	"./ic_clear.svg": 1891,
	"./ic_close_white.svg": 1892,
	"./ic_copy.svg": 1893,
	"./ic_coverage.svg": 1894,
	"./ic_credit-card_payment-method-dark.svg": 1895,
	"./ic_credit-card_payment-method-light.svg": 1896,
	"./ic_data.svg": 1897,
	"./ic_delete_white.svg": 1898,
	"./ic_discount-code.svg": 1899,
	"./ic_edit_white.svg": 1900,
	"./ic_esim.svg": 1901,
	"./ic_expire.svg": 1902,
	"./ic_fup.svg": 1903,
	"./ic_google-pay.svg": 1904,
	"./ic_google-pay_payment-method.svg": 1905,
	"./ic_google.svg": 1906,
	"./ic_help_center.svg": 1907,
	"./ic_install.svg": 1908,
	"./ic_jcb.svg": 1909,
	"./ic_logout.svg": 1910,
	"./ic_long-back-arrow.svg": 1911,
	"./ic_manual_install.svg": 1912,
	"./ic_mastercard.svg": 1913,
	"./ic_notification.svg": 1914,
	"./ic_package.svg": 1915,
	"./ic_paypal_payment-method-dark.svg": 1916,
	"./ic_paypal_payment-method-light.svg": 1917,
	"./ic_play.svg": 1918,
	"./ic_price.svg": 1919,
	"./ic_price_v2.svg": 1920,
	"./ic_qrcode_install.svg": 1921,
	"./ic_routing.svg": 1922,
	"./ic_screenshot.svg": 1923,
	"./ic_sms.svg": 1924,
	"./ic_statistic.svg": 1925,
	"./ic_store_header.svg": 1926,
	"./ic_stripe.svg": 1927,
	"./ic_subscription.svg": 1928,
	"./ic_success.svg": 1929,
	"./ic_success_banner.svg": 1930,
	"./ic_success_order-completed.svg": 1931,
	"./ic_telegram.svg": 1932,
	"./ic_tips.svg": 1933,
	"./ic_unionpay.svg": 1934,
	"./ic_validity.svg": 1935,
	"./ic_visa.svg": 1936,
	"./ic_visa_payment-method.svg": 1937,
	"./ic_visa_saved-card.svg": 1938,
	"./ic_whatsapp.svg": 1939,
	"./icon-ekyc-detail-card-info.svg": 1940,
	"./icon-ekyc-detail-driver-license.svg": 1941,
	"./icon-ekyc-detail-faq-arrow.svg": 1942,
	"./icon-ekyc-detail-finger-print.svg": 1943,
	"./icon-ekyc-detail-identity-card.svg": 1944,
	"./icon-ekyc-detail-jumio.svg": 1945,
	"./icon-ekyc-detail-passport.svg": 1946,
	"./icon-esim-detail-copy-dark.svg": 1947,
	"./icon-esim-detail-copy-light.svg": 1948,
	"./icon-esim-detail-coverage-arrow-dark.svg": 1949,
	"./icon-esim-detail-coverage-arrow-light.svg": 1950,
	"./icon-esim-detail-error-text-field-dark.svg": 1951,
	"./icon-esim-detail-error-text-field-light.svg": 1952,
	"./icon-header-airmoney.svg": 1953,
	"./icon-header-arrow-close.svg": 1954,
	"./icon-header-language.svg": 1955,
	"./icon-header-myesim.svg": 1956,
	"./icon-header-profile.svg": 1957,
	"./icon-header-store.svg": 1958,
	"./icon-hero-rating-appstore.svg": 1959,
	"./icon-hero-rating-googleplay.svg": 1960,
	"./icon-homepage-country-arrow-close.svg": 1961,
	"./icon-homepage-country-arrow-open.svg": 1962,
	"./icon-homepage-country-data-dark-16.svg": 1963,
	"./icon-homepage-country-data-dark-22.svg": 1964,
	"./icon-homepage-country-data-light-16.svg": 1965,
	"./icon-homepage-country-data-light-22.svg": 1966,
	"./icon-info-general-dark.svg": 1967,
	"./icon-info-general-light.svg": 1968,
	"./icon-mob-website-expansion-item-arrow.svg": 1969,
	"./icon-myesims-checklist.svg": 1970,
	"./icon-myesims-nosign.svg": 1971,
	"./icon-myesims-trash-slash.svg": 1972,
	"./icon-myesims-wifi-exclamationmark.svg": 1973,
	"./icon-orders-billed-to.svg": 1974,
	"./icon-package-3g-light.svg": 914,
	"./icon-package-4g-light.svg": 915,
	"./icon-package-5g-light.svg": 916,
	"./icon-package-activation-policy-light.svg": 917,
	"./icon-package-arrow-general-light.svg": 918,
	"./icon-package-calling-credit-light.svg": 919,
	"./icon-package-coverage-dark.svg": 1975,
	"./icon-package-coverage-light.svg": 920,
	"./icon-package-ekyc-micro-light.svg": 921,
	"./icon-package-ekyc-restriction-light.svg": 922,
	"./icon-package-ekyc-validation-light.svg": 923,
	"./icon-package-fup-dark.svg": 1976,
	"./icon-package-fup-light.svg": 924,
	"./icon-package-info-general-light.svg": 925,
	"./icon-package-lte-light.svg": 926,
	"./icon-package-network-light.svg": 927,
	"./icon-package-plan-type-light.svg": 928,
	"./icon-package-price-dark.svg": 1977,
	"./icon-package-price-light.svg": 929,
	"./icon-package-supported-arrow-dark.svg": 1978,
	"./icon-package-supported-arrow-light.svg": 930,
	"./icon-package-topup-option-light.svg": 931,
	"./icon-package-validity-dark.svg": 1979,
	"./icon-package-validity-light.svg": 932,
	"./icon-partner-with-us-breadcrumb-arrow.svg": 1980,
	"./icon-password-hidden-error.svg": 1981,
	"./icon-password-hidden.svg": 1982,
	"./icon-password-visible-error.svg": 1983,
	"./icon-password-visible.svg": 1984,
	"./icon-search-clear.svg": 1985,
	"./icon-search.svg": 1986,
	"./icon-unlimited-dark.svg": 1987,
	"./icon-unlimited-light.svg": 1988,
	"./icon-website-expansion-content-box-bg-sm.svg": 1989,
	"./icon-website-expansion-content-box-bg.svg": 1990,
	"./mail.svg": 1991,
	"./order-async/my-esims/top-up-is-delayed.svg": 933,
	"./order-async/my-esims/top-up-is-failed.svg": 934,
	"./order-async/my-esims/top-up-is-on-the-way.svg": 935,
	"./settings_button.svg": 1992,
	"./tabs-Airmoney.svg": 1993,
	"./tabs-Credit-Card.svg": 1994,
	"./tabs-PayPal.svg": 1995,
	"./telegram.svg": 1996,
	"./tick-light.svg": 1997,
	"./twitter.svg": 1998,
	"./whatsapp.svg": 1999
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 909;